<template>
  <el-form label-position="top" class="base">
    <el-form-item label="表单名称" required>
      <el-input placeholder="请输入..." maxlength="50" show-word-limit v-model="info.name"></el-input>
    </el-form-item>
    <el-form-item label="封面图" class="avatar-uploader">
      <el-upload
        style="display: inline-block"
        :action="commonUrl.uploadImg"
        :headers="commonUrl.headers"
        :data="mediaObj"
        :multiple="false"
        :before-upload="beforeUpload"
        :on-success="uploadSuccess"
        :show-file-list="false"
        accept="image/png, image/jpeg, image/jpg"
      >
        <el-button type="success" size="small">上传封面</el-button>
      </el-upload>
      <div class="desc">推荐图片大小 750*360，不超过2M，支持以下格式图片：jpg, jpeg, png</div>
      <div v-show="info.banner" class="avatar trash">
        <img :src="commonUrl.imgPrefix + info.banner" class="cover" />
        <div class="trashdom"></div>
        <i class="el-icon-delete avatar_edit" @click.stop="removeCover"></i>
      </div>
    </el-form-item>
    <el-form-item label="提交按钮" required>
      <el-input placeholder="请输入..." maxlength="8" show-word-limit v-model="info.submitBtnTxt"></el-input>
    </el-form-item>
    <el-form-item label="介绍信息">
      <v-editor
        class="ueditor"
        id="ueditor"
        :defaultMsg="info.descInfo || ''"
        :config="editorDefault.config"
        ref="editorWeb"
        :editorId="editorDefault.editorId"
      >
      </v-editor>
    </el-form-item>
  </el-form>
</template>

<script scoped>
import commonApi from '@/api/common'
import UE from '@/components/uedtior'
export default {
  data() {
    return {
      commonUrl: commonApi.commonUrl,
      mediaObj: {
        mediaJson: JSON.stringify({
          type: 0
        })
      },
      editorDefault: {
        editorId: new Date().getTime().toString(),
        defaultMsg: '',
        config: {
          initialFrameWidth: 500,
          initialFrameHeight: 550,
          autoHeightEnabled: false
        }
      },
      activityInfo: {
        name: '', // 表单名称
        banner: '', // 封面图
        descInfo: '', // 介绍信息
        submitBtnTxt: '' // 提交按钮
      }
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    'v-editor': UE
  },
  mounted() {
    this.$nextTick(function () {
      let ue = this.$refs.editorWeb
      ue.editor.addListener('blur', () => {
        let data = ue.getUEContent()
        this.$emit('setActivityData', {
          key: 'descInfo',
          value: data || ''
        })
      })
    })
  },
  methods: {
    beforeUpload() {},
    uploadSuccess(res) {
      res = this.$apiOldResDeal(res)
      if (!res.Success) {
        this.$message.error(res.Msg)
      } else {
        this.info.banner = res.Data.url
        this.$message.success('上传成功')
      }
    },
    removeCover() {
      this.info.banner = ''
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.ueditor /deep/.edui-editor,
.ueditor /deep/.edui-editor > div {
  width: auto !important;
}
.base {
  .avatar {
    width: 100px;
    height: 100px;
  }
  .cover {
    display: flex;
  }
  .desc {
    line-height: 1.2;
    margin: 5px 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/rightComponents/activity.vue